import { css } from '@firebolt-dev/css'
import { useEffect, useMemo, useState } from 'react'
import { cls } from '../core/cls'
import { ArrowLeftIcon, ArrowRightIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react'

export function UIEditorFieldFlipper({ options, value, onChange }) {
  const label = useMemo(() => {
    return options.find(o => o.value === value)?.label || 'None'
  }, [value])

  const prev = () => {
    const idx = options.findIndex(o => o.value === value)
    const newIdx = (idx - 1 + options.length) % options.length
    onChange(options[newIdx].value)
  }

  const next = () => {
    const idx = options.findIndex(o => o.value === value)
    const newIdx = (idx + 1) % options.length
    onChange(options[newIdx].value)
  }

  return (
    <div
      className='fieldflip'
      css={css`
        flex: 1;
        display: flex;
        align-items: stretch;
        background: var(--bg4);
        border-radius: 5px;
        height: 34px;
        .fieldflip-btn {
          height: 34px;
          width: 34px;
          display: flex;
          align-items: center;
          justify-content: center;
          &:hover {
            cursor: pointer;
          }
        }
        .fieldflip-label {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      `}
    >
      <div className='fieldflip-btn' onClick={prev}>
        <ChevronLeftIcon size={20} />
      </div>
      <div className='fieldflip-label'>
        <span>{label}</span>
      </div>
      <div className='fieldflip-btn' onClick={next}>
        <ChevronRightIcon size={20} />
      </div>
    </div>
  )
}
